import * as S from "./styles";

/**
 * Cartão de KPI do dashboard.
 *
 * Com `onClick`, o cartão vira um <button> de verdade: pega foco por Tab e
 * dispara com Enter/Espaço. Sem `onClick`, continua a <div> inerte de sempre —
 * quem decide quais cartões têm ação é o backend (mapa `_actions` da resposta de
 * /projects/dashboard), não esta tela.
 */
const KpiComponent = ({ title, value, onClick }) => {
  return (
    <S.Kpi
      as={onClick ? "button" : "div"}
      type={onClick ? "button" : undefined}
      onClick={onClick}
      $clickable={!!onClick}
      aria-label={onClick ? `${title}: ver detalhes` : undefined}
    >
      <span>{title}</span>

      <hr />

      <h3>{value}</h3>
    </S.Kpi>
  );
};

export default KpiComponent;
